import { configureStore } from '@reduxjs/toolkit';
import { firstPageSlice } from './firstPageSlice';
import { globalTooltipSlice } from './globalTooltip';
import { infoCategorySlice } from './infoCategorySlice';
import { productFilterSlice } from './productFilterSlice';
import { scrollYSlice } from './scrollYSlice';
import { userJoinSlice } from './userJoinSlice';
import { userOwnTractorSurveySlice } from './userOwnTractorSurveySlice';
import { userProfileSlice } from './userProfileSlice';
import { userRegionSlice } from './userRegionSlice';
import { userSellTractorSurveySlice } from './userSellTractorSurveySlice';

export const store = configureStore({
  reducer: {
    scrollY: scrollYSlice.reducer,
    globalTooltip: globalTooltipSlice.reducer,
    userProfile: userProfileSlice.reducer,
    userRegion: userRegionSlice.reducer,
    userJoin: userJoinSlice.reducer,
    userOwnTractorSurvey: userOwnTractorSurveySlice.reducer,
    userSellTractorSurvey: userSellTractorSurveySlice.reducer,
    infoCategory: infoCategorySlice.reducer,
    productFilter: productFilterSlice.reducer,
    firstPage: firstPageSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
